// extracted by mini-css-extract-plugin
export default {"card":"card_card__jyWfG","iconContainer":"card_iconContainer__1Tj74","title":"card_title__7VyfB","description":"card_description__HF8f1"};